<template>
    <div class="pane-template" v-if="tools.currentPaneKey === 'order'">
        <pane-header
            :title="order.title"
            :subtitle="order.sub"
            :tools="tools"
            v-if="!hideHeader"
            :appIconKey="order.type"
            :hasCloseIcon="true"
        />
        <ui-scrollable-container>
            <pane-content>
                <order-details :order="order" />
                <pane-section title="Related items" preset="item" :itemCount="1" :tools="tools" />
            </pane-content>
        </ui-scrollable-container>
    </div>
</template>

<script>
    export default {
        name: 'pane-order-template',
        props: ['tools', 'hideHeader'],
        computed: {
            order() {
                return this.tools.currentView.data.pane;
            },
        },
    };
</script>



// WEBPACK FOOTER //
// OrderPaneTemplate.vue?9672165c